'use client';

import { WagmiProvider } from 'wagmi';
import { useWagmiConfig } from '@/libs/wagmi-client';
import React from 'react';

/**
 * WalletProvider 组件
 * 提供基础的 WagmiProvider 以支持 wagmi hooks（如 useAccount, useDisconnect 等）
 * RainbowKit 功能已移至 form-common 内部，这里不再包含
 */
export default function WalletProvider({ children }: { children: React.ReactNode; }) {
  const wagmiConfig = useWagmiConfig();

  return (
    <WagmiProvider config={wagmiConfig}>
      {children}
    </WagmiProvider>
  );
}